import type { AdmissionEnquiryStatus } from '../../../types/admissions';

/** Every enquiry status in the order a family moves through them, with what each means. */
export const ENQUIRY_STATUSES: Array<{ value: AdmissionEnquiryStatus; hint: string }> = [
  { value: 'new', hint: 'Not called yet' },
  { value: 'called', hint: 'Spoke to the family' },
  { value: 'applied', hint: 'They’ve applied' },
  { value: 'not_interested', hint: 'Not going ahead' },
];
